import { axiosService } from 'shared/helpers/axios';

/** "Post on 29 October 2026" */
export const postReflectionTitle = (date = new Date()) =>
  `Post on ${new Date(date).toLocaleDateString(undefined, { day: 'numeric', month: 'long', year: 'numeric' })}`;

/**
 * A post (with hashtags) saved as one of the author's reflections, in one step: titled "Post on <date>", its
 * text, its tags. Published when it can be; a published reflection needs 300 characters and the author's
 * agreement to the reflection guidelines, so otherwise it is kept as a draft to finish on the Reflections page.
 * Returns { id, status: 'published' | 'draft', reason?: 'length' | 'guidelines' }.
 */
export async function savePostAsReflection({ body, tags, date, postId }) {
  const base = { title: postReflectionTitle(date), content: body, tags: (tags || []).slice(0, 5), media_type: 'text',
    ...(postId && { source_post: postId }) };       // the post then opens this reflection instead of offering it again
  try {
    const res = await axiosService.post('/reflections/', { ...base, status: 'published' });
    return { id: res.data.id, status: 'published' };
  } catch (err) {
    const data = err.response?.data || {};
    if (err.response?.status !== 400 || !(data.content || data.accept_rules)) throw err;
    const res = await axiosService.post('/reflections/', { ...base, status: 'draft' });
    return { id: res.data.id, status: 'draft', reason: data.accept_rules ? 'guidelines' : 'length' };
  }
}

/** What to tell the author afterwards. */
export const reflectionSavedMessage = ({ status, reason }) => (status === 'published'
  ? 'Added to your reflections'
  : reason === 'guidelines'
    ? 'Saved as a draft reflection: agree to the reflection guidelines once to publish it'
    : 'Saved as a draft reflection: published reflections need at least 300 characters');
